import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router";

import { AuthGuard } from "./auth/AuthGuard";
import { LoginPage } from "./auth/LoginPage";
import { WorkerLayout } from "./components/WorkerLayout";
import {
  HomePage,
  NotFoundPage,
  OnboardingPage,
  RecentShiftPage,
} from "./pages/WorkerPages";

const AdminApplication = lazy(() =>
  import("./admin/AdminApplication").then((module) => ({
    default: module.AdminApplication,
  })),
);

export const router = createBrowserRouter([
  { path: "/", element: <Navigate to="/home" replace /> },
  { path: "/login", element: <LoginPage /> },
  {
    element: (
      <AuthGuard>
        <WorkerLayout />
      </AuthGuard>
    ),
    children: [
      { path: "/home", element: <HomePage /> },
      {
        path: "/shift",
        lazy: async () => ({
          Component: (await import("./pages/WorkerShiftPage")).WorkerShiftPage,
        }),
      },
      {
        path: "/guides",
        lazy: async () => ({
          Component: (await import("./pages/WorkerContentPages"))
            .WorkerGuidesPage,
        }),
      },
      {
        path: "/search",
        lazy: async () => ({
          Component: (await import("./pages/WorkerContentPages"))
            .WorkerSearchPage,
        }),
      },
      { path: "/onboarding", element: <OnboardingPage /> },
      {
        path: "/emergency",
        lazy: async () => ({
          Component: (await import("./pages/WorkerEmergencyPage"))
            .WorkerEmergencyPage,
        }),
      },
      { path: "/recent-shift", element: <RecentShiftPage /> },
    ],
  },
  {
    path: "/admin/*",
    element: (
      <AuthGuard>
        <Suspense
          fallback={
            <main className="page" aria-busy="true">
              <p>Opening administration…</p>
            </main>
          }
        >
          <AdminApplication />
        </Suspense>
      </AuthGuard>
    ),
  },
  { path: "*", element: <NotFoundPage /> },
]);
